import { render, staticRenderFns } from "./ShippingDetails.vue?vue&type=template&id=7e63b03a&scoped=true"
import script from "./ShippingDetails.vue?vue&type=script&lang=js"
export * from "./ShippingDetails.vue?vue&type=script&lang=js"
import style0 from "./ShippingDetails.vue?vue&type=style&index=0&id=7e63b03a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e63b03a",
  null
  
)

export default component.exports